import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import editSquareGreyIcon from 'assets/images/icons/edit-square-grey.svg';
import transGreyIcon from 'assets/images/icons/trash-grey.svg';
import uploadWhiteIcon from 'assets/images/icons/upload-white.svg';
import FormButton from 'components/form-components/FormButton';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const ImageUploadCard = ({ imageWidget, setImageWidget }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error(t('text_dashboard_image_supported_types'));
      e.target.value = '';
      return;
    }

    if (file) {
      setImageWidget((prevState) => ({
        ...prevState,
        newImage: file,
      }));
    }
  };

  const handleDelete = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      setImageWidget((prevState) => ({
        ...prevState,
        newImage: null,
      }));
    }
  };

  const handleEdit = () => {
    fileInputRef.current?.click();
  };

  const getImageSrc = (value) => {
    if (!value) return null;
    if (typeof value === 'string') return value;
    return URL.createObjectURL(value);
  };

  return (
    <div className='d-flex flex-column gap-1'>
      <div>
        <label className='theme-text-black-1 theme-size-1_1 theme-font-inter-medium'>
          {t('field_image')}
        </label>
        <span className='lh-1 theme-size-1_5 theme-text-red-1 px-1'>*</span>
      </div>
      <div className='d-flex gap-2 align-items-center'>
        <input
          ref={fileInputRef}
          type='file'
          accept='.png,.jpg,.jpeg'
          hidden
          onChange={handleFileChange}
        />
        <div
          className={`image-card theme-background-white-1 d-flex justify-content-center align-items-center rounded-sm ${
            imageWidget.newImage || imageWidget.oldImageUrl ? '' : 'border-dashed'
          }`}
        >
          {imageWidget.newImage || imageWidget.oldImageUrl ? (
            <img
              src={getImageSrc(imageWidget.newImage || imageWidget.oldImageUrl)}
              className='rounded'
              alt='attachment'
            />
          ) : (
            <FormButton
              text='button_upload'
              icon={uploadWhiteIcon}
              variant='green-1'
              classes='mt-3'
              onClick={handleEdit}
            />
          )}
        </div>

        <div>
          {(imageWidget.newImage || imageWidget.oldImageUrl) && (
            <>
              <img
                className='mx-1 cursor-pointer'
                src={editSquareGreyIcon}
                alt='Edit'
                onClick={handleEdit}
              />
              <img
                className='mx-1 cursor-pointer'
                src={transGreyIcon}
                alt='Delete'
                onClick={handleDelete}
              />
            </>
          )}
        </div>
      </div>
      <span>{t('text_dashboard_image_supported_types')}</span>
    </div>
  );
};

ImageUploadCard.propTypes = {
  value: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  imageWidget: PropTypes.object.isRequired,
  setImageWidget: PropTypes.func.isRequired,
};

export default ImageUploadCard;
